import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';

/**
 * Visibility Service checks for given Rules if something is visible
 */
@Injectable({
  providedIn: 'root',
})
export class SjobTypeVisibilityService implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'sjobType';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private servicejobsService: ServicejobsService,
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    const sjobId = this.clientStateService.theState.getValue()?.serviceJobId;
    if (sjobId == null) {
      return false;
    }

    const sjob = this.servicejobsService.getServiceJobById(sjobId);
    if (sjob == null) {
      return false;
    }

    const neededSjobTypeId = params?.servicejobtypeid;
    if (neededSjobTypeId == null) {
      return false;
    }

    return sjob.servicejobtype?.id?.imsId == neededSjobTypeId;
  }

  // Private Functions
}
